import {CLEAR_ERRORS, GET_ERRORS} from './types';

export const ClearErrors = () => dispatch => {
  dispatch ({type: CLEAR_ERRORS});
};
export const SetErrors = (type, msg) => dispatch => {
  dispatch ({type: GET_ERRORS, payload: {error: {type, msg}}});
};
